import React from "react";
import { createPortal } from "react-dom";

const ConfirmModal = ({
  open,
  title,
  description,
  icon,
  iconBg = "bg-yellowlight",
  iconColor = "text-red-600",
  confirmText = "Confirm",
  confirmClass = "bg-yellowlight hover:bg-yellowdark hover:text-yellowlight text-yellowdark",
  cancelText = "Cancel",
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />

      {/* Modal */}
      <div
        className="relative bg-dry rounded-lg shadow-xl w-full max-w-md p-6 z-10 border border-border m-3"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-4">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center ${iconBg} ${iconColor}`}
          >
            {icon}
          </div>
          <h2 className="text-lg font-semibold text-yellowlight">{title}</h2>
        </div>

        <p className="text-textGray mb-6 text-sm">{description}</p>

        <hr className="border border-border mb-3" />

        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="border border-border text-textGray px-4 py-2 rounded-md text-sm"
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            className={`${confirmClass} px-4 py-2 rounded-md text-sm`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
